import QuoteAdmin from "./quotes"
import { Consumer, Provider, QuotesContext } from "./quotes.context"

export { Consumer, Provider, QuotesContext }
export { default as QuotesPanel } from "./quotes.panel"
export default QuoteAdmin
